import { useEffect, useState } from 'react';
import CustomerInfoService from '~/api-services/CustomerInfoService';
import {
    PaymentProvider1BillingField,
    GetPaymentProvider1DirectCardDataResponse
} from '~/api-services/CustomerInfoService/types';

export const usePaymentProvider1DirectCardData = (provider: string, paymentMethod: string, currency: string) => {
    const [directCardData, setDirectCardData] = useState<GetPaymentProvider1DirectCardDataResponse>();
    const [billingFields, setBillingFields] = useState<PaymentProvider1BillingField[]>([]);

    useEffect(() => {
        loadData();
    }, []);

    async function loadData() {
        switch (provider) {
            case 'PAYMENT_PROVIDER_1':
                {
                    const { status, data } =  await CustomerInfoService.getDirectCardDataPaymentProvider1(paymentMethod, currency);
                    if (status === 200 && data.status) {
                        setDirectCardData(data.returnData);
                        setBillingFields(data.returnData.billingFields);
                    }
                }
                break;
            default:
                setDirectCardData(undefined);
        }
    }

    return {
        directCardData,
        billingFields,
        setBillingFields
    };
};
